module.exports = __webpack_public_path__ + "img/19_7.d949daa8.png";